import React from "react";
import {AppState} from "../../../../../app/types";
import {ActionsBar, ActionsBarOption} from "../../../../../app/components/ActionsBar";
import {getBotsState} from "../../../logic/getBotsState";
import {hasPermission} from "../../../../../app/permissions";
import {Breadcrumbs} from "../../../../../app/components/Breadcrumbs";
import {conversation} from "../types";
import { updateConversation } from "../logic/getConversations";

export const ConversationsActionsBar = (appState: AppState,  bot: string, selectedConversation: conversation | undefined, setOptionsDialog: any) => {
    const state = getBotsState(appState);

    const options: ActionsBarOption[] = hasPermission("conversationsupdate", appState.auth.permissions, getBotsState(appState).path[1])
    ? [
        {
            title: "Take",
            disabled: !selectedConversation || selectedConversation.ownerid === appState.auth.userEmail,
            action: () => {
                selectedConversation && updateConversation(appState, bot, appState.auth.userEmail, 1, selectedConversation);
                return false;
            }
        },
        {
            title: "Give",
            disabled: !selectedConversation || selectedConversation.ownerid !== appState.auth.userEmail,
            action: () => {
                selectedConversation && updateConversation(appState, bot, bot, 1, selectedConversation);
                return false;
            }
        },
        {
            title: "Options",
            disabled: false,
            action: () => {
                setOptionsDialog(true);
                return false;
            }
        }
    ]
    : [];

    const actions = appState.actions.botsControl;
    const before = actions
        ? [
              <Breadcrumbs
                  key={"breadcrumbs"}
                  {...{
                      path: state.path,
                      goBackUpPath: actions.goBackUpPath,
                      addToPath: actions.addToPath
                  }}
              />
          ]
        : [];

    return <ActionsBar {...{before, options}} />;
};
